//action types
export const FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD';
export const FORCE_CHANGE_PASSWORD_RESULT = 'FORCE_CHANGE_PASSWORD_RESULT';